// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"StatsSection_text-gradient__1QMtZ","stat":"StatsSection_stat__24Hxd"};